<template>
    <div class="wrapper-form-input-listasuspensa">
        <div class="control">
            <TrfDraggable pKeyAttribute="uuidEditor" :pAllowDropAround="false" :pItems="opcoes" :pGroupName="'cadastro-opcoes-select'" :pUseCustomHandler="true" pCustomHandlerClass="drag-select-handle" style="max-width:700px;width:100%;" @changed:items="setItems">
              <template #item="{item, index}">
                <div class="drag-listasuspensa-wrapper columns">
                    <a class="button is-white drag-select-handle drag-handle-body px-0 py-0 column is-narrow"><span class="mdi mdi-drag drag-select-handle pt-2"></span></a>
                    <span class="column ordering-number is-narrow py-0">{{ item.ordem }}.</span>
                    <div class="campo columns column py-0" :class="{'has-error': !item.label}">
                        <TrfToolbarTextEditorInline
                            class="column py-0"
                            :id="item.uuidEditor"
                            :defaultText="getTitulo(item)"
                            @changeText="($event, ref$) => setValue($event, index, ref$, item)"
                            :is-obrigatorio="true"
                            tag="p"
                            :editorStyle="`.wrapper-form-input-listasuspensa p.mce-content-body { width: 100%; background:#FFF; font-size: 1rem!important; color: #666!important; padding: .25rem .75rem; border-bottom: 1px solid #33333300; transition: border 0.35s ease-in-out 0s} p.mce-content-body:focus-visible, p.mce-content-body:hover { outline: 0 none; border-bottom: 1px solid ${estilosPadrao.CorPrimaria}FF}`"
                            :maxlength="100"
                            :ref="`label${index}`"
                            :toolbar-options="''"
                        ></TrfToolbarTextEditorInline>
                    </div>
                    <a @click="deleteOption(item, index)" class="button is-white px-0 py-0 column is-narrow btn-delete"><span class="mdi mdi-close pt-1"></span></a>
                </div>
              </template>
            </TrfDraggable>
            <p v-if="!hasOptions" class="has-error mb-4 ml-5 pl-4">É necessário cadastrar ao menos uma opção.</p>
            <p class="drag-listasuspensa-wrapper columns pl-4 pt-3">
                <span class="column ordering-number is-narrow pr-5">{{ opcoes.length + 1 }}.</span>
                <span class="column adicionar-label is-narrow" tabindex="0" @click="adicionarOpcao" @keypress.enter="adicionarOpcao">Adicionar opção</span>
            </p>
        </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  import { stylesUtils } from '../../../util/styles.utils';
  import { gerarGUID } from '../../../util/uuid.utils';

  const DEFAULT_OPTIONS = [
        {
            ordem: 1,
            label: "Opção 1",
            labelHtml: "Opção 1",
            uuidEditor: gerarGUID()
        }
    ]

  export default {
    name: 'TrfListaSuspensa',
    emits: ['update:value', 'update:opcoes'],
    components: {
        TrfToolbarTextEditorInline: defineAsyncComponent(() => import('../../ToolbarTextEditor/inline.vue')),
        TrfDraggable: defineAsyncComponent(() => import('../../Draggable/index.vue'))
    },
    props: {
        pHasOpcaoOutro: {
            type: Boolean,
            default: false
        },
        pOpcoes: {
            type: Array,
            default: () => Object.assign([], DEFAULT_OPTIONS)
        },
        hasOptions: {
            type: Boolean,
            default: true
        }
    },
    data() {
      return {
        estilosPadrao: '',
        value: '',
        hasOpcaoOutro: this.pHasOpcaoOutro,
        opcoes: this.pOpcoes
      };
    },
    computed: {
    },
    methods: {
        getTitulo(item) {
            const labelFallback = item.label? item.label : `Opção ${item.ordem}`
            return item.labelHtml? item.labelHtml : labelFallback
        },
        async setValue(value, index, ref, item) {
            const opcaoIndex = this.opcoes.findIndex(opcao => opcao.uuidEditor == item.uuidEditor);
            if (opcaoIndex < 0) return '';
            const opcaoAtualizada = {
                ...this.opcoes[opcaoIndex],
                labelHtml: value,
                label: ref.getValueAsText()
            }
            this.opcoes[opcaoIndex] = opcaoAtualizada
            await this.$nextTick()
            this.emitOpcoes(this.opcoes)
        },
        async setItems(items) {
            if (!this.opcoes || !Array.isArray(items)) return [];
            items.forEach((item, index) => {
                item.ordem = index+1
            })
            this.opcoes = items
            await this.$nextTick()
            this.updateOptionsLabels()
        },
        updateOptionsLabels() {
            this.opcoes.forEach((item, index) => {
                if (!item.uuidEditor || !this.$refs[item.uuidEditor]) return;
                item.label = this.$refs[item.uuidEditor].iniciarTextEditorComValor(item.labelHtml)
            })
            this.emitOpcoes(this.opcoes)
        },
        emitValue(value) {
            this.$emit('update:value', value)
        },
        emitOpcoes(opcoes) {
            this.$emit('update:opcoes', opcoes)
        },
        adicionarOpcao() {
            const opcaoDeclarada = {
                ordem: this.opcoes.length + 1,
                label: `Opção ${this.opcoes.length + 1}`,
                labelHtml: `Opção ${this.opcoes.length + 1}`,
                uuidEditor: gerarGUID()
            }
            this.opcoes.push(opcaoDeclarada)
            this.emitOpcoes(this.opcoes)
        },
        deleteOption(item, itmIndex) {
            const opcoesLimpas = this.opcoes.filter((opcao, index) => {
                if (!opcao.uuidEditor && !item.uuidEditor) {
                    return itmIndex != index
                }
                return opcao.uuidEditor != item.uuidEditor
            })
            this.setItems(opcoesLimpas)
        }
    },
    mounted() {
        this.estilosPadrao = stylesUtils.adquirirEstilosCookie();
        this.emitOpcoes(this.opcoes)
    }
  };
  </script>
  <style lang="scss" scoped>
  .has-error {
    color:#a94442FF;
  }
  .wrapper-form-input-listasuspensa {
      @media screen and (max-width: 768px) {
          .drag-listasuspensa-wrapper {
              display:flex;
              .ordering-number, .drag-select-handle, .adicionar-label, .btn-delete {
                flex: 0 0 auto;
              }
          }
      }
  }
 </style>
 <style lang="scss">
 .wrapper-form-input-listasuspensa .drag-listasuspensa-wrapper .campo.has-error .mce-content-body {
     border-bottom-color: #a94442FF!important;
 }
 </style>